import { createMemo } from 'solid-js';
import SignatureModal from '../../st-signature-modal/st-signature-modal';
import { requireAttendanceGridContext } from '../st-attendance-grid';
import { StatusVerification } from '../../../api';

export function SignatureModalWrapper() {
    const ctx = requireAttendanceGridContext();

    const summaryMessage = createMemo(() => {
        const sections = ctx.attendance[0]();

        const confirmed = sections.filter(s => s.status === StatusVerification.Accepted);
        const denied = sections.filter(s => s.status === StatusVerification.Denied);

        let message = 'Please sign below to submit your attendance review:\n\n';

        if (confirmed.length > 0) {
            message += `Confirmed (${confirmed.length}): ${confirmed.map(s => s.courseName ?? s.sectionName).join(', ')}\n\n`;
        }

        if (denied.length > 0) {
            message += `Denied (${denied.length}): ${denied.map(s => s.courseName ?? s.sectionName).join(', ')}`;
        }

        return message;
    });

    const handleSubmit = (signatureBase64: string) => {
        ctx.submitReportWithSignature(signatureBase64);
    };

    const handleCancel = () => {
        ctx.showSignatureModal[1](false);
    };

    return (
        <SignatureModal
            show={ctx.showSignatureModal[0]()}
            title="Sign to Submit Attendance"
            message={summaryMessage()}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
        />
    );
}
